import { clientSessionViewStore } from '../../services/clientSessionViewStore.js'
import { coerceUiLocale, type UiLocale } from '../core/contracts.js'
import {
  ensureSessionCapability,
  SESSION_HEADER,
} from '../core/session/session-identity.js'
import type { SessionProjectionEnvelopeV1 } from '../core/session/session-projection.js'
import { logger } from './logger.js'

export async function persistSessionUiLocale(params: {
  sessionId: string
  uiLocale: UiLocale
}): Promise<void> {
  const sessionId = params.sessionId.trim()
  const uiLocale = coerceUiLocale(params.uiLocale)
  if (!sessionId || !uiLocale) return

  try {
    await ensureSessionCapability(sessionId)
    const response = await fetch('/api/consent', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        [SESSION_HEADER]: sessionId,
      },
      body: JSON.stringify({ sessionId, uiLocale }),
    })
    const payload: unknown = await response.json().catch(() => ({}))
    if (!response.ok) {
      logger.warn('[persistSessionUiLocale] consent failed', {
        sessionId,
        status: response.status,
      })
      return
    }
    const envelope =
      payload &&
      typeof payload === 'object' &&
      !Array.isArray(payload) &&
      (payload as Record<string, unknown>).projectionEnvelope &&
      typeof (payload as Record<string, unknown>).projectionEnvelope === 'object'
        ? ((payload as Record<string, unknown>).projectionEnvelope as SessionProjectionEnvelopeV1)
        : undefined
    if (envelope) clientSessionViewStore.acceptServerProjection(envelope)
  } catch (error) {
    logger.warn('[persistSessionUiLocale] failed', {
      sessionId,
      error: error instanceof Error ? error.message : String(error),
    })
  }
}
